module.exports = __webpack_public_path__ + "img/balsamiq.05247782.svg";